// Tiny formatting helpers shared across portal lists.

export function fmtRelativeTime(iso: string | null | undefined): string {
  if (!iso) return "—"
  const then = new Date(iso).getTime()
  if (Number.isNaN(then)) return "—"
  const diff = Date.now() - then
  if (diff < 0) return "just now"
  const m = Math.floor(diff / 60_000)
  if (m < 1) return "just now"
  if (m < 60) return `${m}m ago`
  const h = Math.floor(m / 60)
  if (h < 24) return `${h}h ago`
  const d = Math.floor(h / 24)
  if (d < 30) return `${d}d ago`
  const mo = Math.floor(d / 30)
  if (mo < 12) return `${mo}mo ago`
  return `${Math.floor(mo / 12)}y ago`
}

// Compact "X ago" with multi-unit precision under 1 day. Examples:
//   45s        → "45s ago"
//   3m 12s     → "3m 12s ago"
//   2h 15m     → "2h 15m ago"
//   23h 59m    → "23h 59m ago"
//   1d, 2d, … → "1d ago", "2d ago" (single unit at the day scale)
// Returns "never" when iso is null/empty (the "no calls yet" case for endpoints).
export function fmtCompactRelative(iso: string | null | undefined): string {
  if (!iso) return "never"
  const then = new Date(iso).getTime()
  if (Number.isNaN(then)) return "—"
  const sec = Math.max(0, Math.floor((Date.now() - then) / 1000))
  if (sec < 60) return `${sec}s ago`
  const m = Math.floor(sec / 60), s = sec % 60
  if (m < 60) return s ? `${m}m ${s}s ago` : `${m}m ago`
  const h = Math.floor(m / 60), mr = m % 60
  if (h < 24) return mr ? `${h}h ${mr}m ago` : `${h}h ago`
  const d = Math.floor(h / 24)
  if (d < 30) return `${d}d ago`
  const mo = Math.floor(d / 30)
  if (mo < 12) return `${mo}mo ago`
  return `${Math.floor(mo / 12)}y ago`
}

export function fmtNumber(n: number): string {
  return n.toLocaleString()
}
